import * as actions from "./actions";

const initialState = {
  isLoading: false,
  collectionIsLoading: false,
  searchString: "",
  searchResults: [],
  miscSearchResults: {},
  collectionResults: [],
};

export const STATE_KEY = "search";

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.END_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: false,
      };
    case actions.START_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case actions.LOAD_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: [...state.searchResults, ...action.payload.items],
        totalResults: action.payload.total,
        searchUrl: action.payload.href,
        nextPageToken: action.payload.nextPageToken,
        isMore: !!action.payload.nextPageToken,
      };
    case actions.EMPTY_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: [],
        totalResults: null,
        searchUrl: "",
        nextPageToken: null,
        isMore: false,
      };
    case actions.EDIT_SEARCH_STRING:
      return {
        ...state,
        isLoading: true,
        searchString: action.string,
      };
    case actions.LOAD_SINGLE_TRACK:
      return {
        ...state,
        searchResults: [action.payload],
        singleTrack: action.payload,
      };
    case actions.LOAD_MISC_SEARCH_RESULTS:
      return { ...state, miscSearchResults: action.payload };
    case actions.START_COLLECTION_REQUEST:
      return { ...state, collectionIsLoading: true };
    case actions.END_COLLECTION_REQUEST:
      return { ...state, collectionIsLoading: false };
    case actions.LOAD_COLLECTION_RESULTS:
      return { ...state, collectionResults: action.payload.items };
    default:
      return state;
  }
};

export default searchReducer;
